var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Day-header"},[_c('div',{staticClass:"Day-header__name"},[_vm._v("\n        "+_vm._s(_vm.day.format('dddd'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"Day-header__date",class:{'Day-header__date--today': _vm.today}},[_vm._v("\n        "+_vm._s(_vm.day.format('D'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f08d02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DayHeader.vue
// module id = 154
// module chunks = 0